import { useEffect, useRef, useState } from "react";
import '../css/FileView.css'
import { useNavigate } from "react-router-dom";
import { Snackbar } from "@mui/material";
   export const BuildTree = ({addr, allItems, parent, sessionId, clientId, setAllFiles, mainVersion, nextList, setStorageUsage}) => {
    const [items, setItems] = useState([])
    const [enableDrag, setEnableDrag] = useState(true)
    const [moveItem, setMoveItem] = useState([])
    const [currentlyMoving, setCurrentlyMoving] = useState(false)
    const [moveType, setMoveType] = useState(null)
    const [targetDrop, setTargetDrop] = useState(null)
    const [targetType, setTargetType] = useState(null)
    const navigate = useNavigate()
    const [checkedItems, setCheckedItems] = useState({})
    const [newNote, setNewNote] = useState({});
    const [newBoard, setNewBoard] = useState({});
    const [renameFile, setRenameFile] = useState({});
    const [snackbar, setSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState(null)
    const [deleteFile, setDeleteFile] = useState({})
    const inputRef = useRef({})
    const inputRefBoard = useRef({})
    const inputRenameRef = useRef({})
    const [newFolder, setNewFolder] = useState({});
    const inputFolderRef = useRef({});
    useEffect(()=>{
      items.forEach((item) => {
        if(item.parent === 'homeroot') {
        setCheckedItems(prevState => ({
          ...prevState,
          [item.id]: true
        }));
        }
      })
      allItems.forEach((item)=>{
        try {
          const newId = localStorage.getItem(item.id)
          if(newId === 'true') {
            setCheckedItems(prevState => ({
              ...prevState,
              [item.id]: true
            }))
          }
        }catch(e) {
          console.error(e)
        }
      })
    }, [allItems])
    useEffect(() => {
      try {
        if(parent === 'homeroot') {
          
      setItems([
        {
          name: 'Your stuff',
          parent: 'homeroot',
          id: 0,
          publicId: 0,
          type: 'folder'
        },
        ...allItems
      ]);
        }else if(parent === 'shared') {
          
          
        setItems([
          {
            name: 'Shared with you',
            parent: 'shared',
            id: '-1',
            publicId: '-1',
            type: 'folder'
          },
          ...allItems
        ]);
        }else {
          setItems([...allItems])
        }
    }catch(error) {
      console.error(error)
    }
    }, [allItems]);
  const focusOnRenameInput = async (index, maxAttempts = 5, delay = 500) => {
    let attempts = 0;
    while (attempts < maxAttempts) {
      if (inputRenameRef.current[index]) {
        inputRenameRef.current[index].focus();
        inputRenameRef.current[index].value = '';
        break; // Exit loop if focusing is successful
      } else {
        console.error('No inputRenameRef found!');
        await new Promise(resolve => setTimeout(resolve, delay)); // Wait for some time before next attempt
        attempts++;
      }
    }
  };
  const handleCheckboxChange = (name) => {
    setCheckedItems(prevState => {
      const updatedState = {
        ...prevState,
        [name]: !prevState[name]
      };
      localStorage.setItem(name, JSON.stringify(updatedState[name]))
  
      return updatedState;
    });
  };

  const handleCheckboxOpen = (name) => {
    setCheckedItems(prevState => ({
      ...prevState,
      [name]: true
    }));
    setNewNote(prevState => ({
      ...prevState,
      [name]: {
        ...prevState[name],
        active: true
      }
    }));
  };
  
  const renameFileStageTwo = (type,id, index) => {
    setRenameFile(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: false
      }
    }));
    
    if(inputRenameRef.current[index].value === null || inputRenameRef.current[index].value === undefined || inputRenameRef.current[index].value === '') {
      return;
    }
    const name = inputRenameRef.current[index].value
    renameFileSend(type, id, name)

  };
  
  const handleCancelRename = (index) => {
    setRenameFile(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: false
      }
    }));
  };
  
  const focusOnInput = async (index, maxAttempts = 5, delay = 500) => {
    let attempts = 0;
    while (attempts < maxAttempts) {
      if (inputRef.current[index]) {
        inputRef.current[index].focus();
        inputRef.current[index].value = '';
        break; // Exit loop if focusing is successful
      } else {
        console.error('No inputRef found!');
        await new Promise(resolve => setTimeout(resolve, delay)); // Wait for some time before next attempt
        attempts++;
      }
    }
  };
  const focusOnFolderInput = async (index, maxAttempts = 5, delay = 500) => {
    let attempts = 0;
    while (attempts < maxAttempts) {
      if (inputFolderRef.current[index]) {
        inputFolderRef.current[index].focus();
        inputFolderRef.current[index].value = '';
        break; // Exit loop if focusing is successful
      } else {
        console.error('No inputFolderRef found!');
        await new Promise(resolve => setTimeout(resolve, delay)); // Wait for some time before next attempt
        attempts++;
      }
    }
  };
  
  
  const focusOnInputBoard = async (index, maxAttempts = 5, delay = 500) => {
    let attempts = 0;
    while (attempts < maxAttempts) {
      if (inputRefBoard.current[index]) {
        inputRefBoard.current[index].focus();
        inputRefBoard.current[index].value = '';
        break; // Exit loop if focusing is successful
      } else {
        console.error('No inputRefBoard found!');
        await new Promise(resolve => setTimeout(resolve, delay)); // Wait for some time before next attempt
        attempts++;
      }
    }
  };
  
  const newNoteStageOne = (path, index) => {
    setNewNote(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: true
      }
    }));

    focusOnInput(index);

  };
  
  const newBoardStageOne = (path, index) => {
    setNewBoard(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: true
      }
    }));

    focusOnInputBoard(index);

  };
  
  
  const newFolderStageOne = (path, index) => {
    setNewFolder(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: true
      }
    }));

    focusOnFolderInput(index);

  };
  async function createNote(name, parent) {
    setSnackbar(true);
    setSnackbarMessage('Creating note...')
    if(clientId && sessionId) {      
      try {let endpoint = `${addr}:6060`
        const agent = window.navigator.userAgent;
        const message = {
          type: 'create-note',
          version: mainVersion,
          name,
          parent,
          clientId,
          sessionId,
          agent
        }
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(message)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        // If you need to handle the response
        
        const responseData = await response.json();
        if(responseData) {
          setSnackbarMessage(responseData.message)
          setTimeout(()=>{
            setSnackbar(false)
          }, 4000)
          let endpoint = 'https://donotes-server.com:7070'
            
            if(window.location.hostname !== 'v8.donotes.app') {
              endpoint = `${addr}:7070`;
            }
            try {
                
              const fetchReq = {
                type: 'fetch-data',
                sessionId,
                clientId,
                agent,
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(fetchReq)
              })
              if(!response.ok ) {
                throw new Error('Network response was not ok');                  
              }
              const responseData = await response.json();
              if(responseData && responseData.type) {
                if(responseData.type === 'data-from-server') {
                  try {
                    
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                  }catch(error) {
                    console.error(error)
                  }
                }else if(response.message) {
                  //todo snackbar
                  //setOpenSnackbar(true)
                  //setSnackbarMessage(response.message)
                }
              }
            }
            catch(error) {
              console.error(error)
            }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
  
  async function createBoard(name, parent) {
    if(clientId && sessionId) {      
      try {
        
        let endpoint = `${addr}:6060`
        const agent = window.navigator.userAgent;
        const message = {
          type: 'create-board',
          version: mainVersion,
          name,
          parent,
          clientId,
          sessionId,
          agent
        }
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(message)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        // If you need to handle the response
        
        const responseData = await response.json();
        if(responseData) {
          let endpoint = 'https://donotes-server.com:7070'
            
            if(window.location.hostname !== 'v8.donotes.app') {
              endpoint = `${addr}:7070`;
            }
            try {
                
              const fetchReq = {
                type: 'fetch-data',
                sessionId,
                clientId,
                agent,
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(fetchReq)
              })
              if(!response.ok ) {
                throw new Error('Network response was not ok');                  
              }
              const responseData = await response.json();
              if(responseData && responseData.type) {
                if(responseData.type === 'data-from-server') {
                  try {
                    
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                  }catch(error) {
                    console.error(error)
                  }
                }else if(response.message) {
                  //todo snackbar
                  //setOpenSnackbar(true)
                  //setSnackbarMessage(response.message)
                }
              }
            }
            catch(error) {
              console.error(error)
            }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
  
  async function createFolder(name, parent) {
    if(clientId && sessionId) {      
      try {let endpoint = `${addr}:6060`
        const agent = window.navigator.userAgent;
        const message = {
          type: 'create-folder',
          version: mainVersion,
          name,
          parent,
          clientId,
          sessionId,
          agent
        }
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(message)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        // If you need to handle the response
        
        const responseData = await response.json();
        if(responseData) {
          let endpoint = 'https://donotes-server.com:7070'
            
            if(window.location.hostname !== 'v8.donotes.app') {
              endpoint = `${addr}:7070`;
            }
            try {
                
              const fetchReq = {
                type: 'fetch-data',
                sessionId,
                clientId,
                agent,
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(fetchReq)
              })
              if(!response.ok ) {
                throw new Error('Network response was not ok');                  
              }
              const responseData = await response.json();
              if(responseData && responseData.type) {
                if(responseData.type === 'data-from-server') {
                  try {
                    
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                  }catch(error) {
                    console.error(error)
                  }
                }else if(response.message) {
                  //todo snackbar
                  //setOpenSnackbar(true)
                  //setSnackbarMessage(response.message)
                }
              }
            }
            catch(error) {
              console.error(error)
            }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
  
  async function renameFileSend(type,id, name) {
    if(clientId && sessionId) {      
      try {let endpoint = `${addr}:6060`
        const agent = window.navigator.userAgent;
        const message = {
          type: `rename-${type}`,
          version: mainVersion,
          name,
          id,
          clientId,
          sessionId,
          agent
        }
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(message)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        // If you need to handle the response
        
        const responseData = await response.json();
        if(responseData) {
          let endpoint = 'https://donotes-server.com:7070'
            
            if(window.location.hostname !== 'v8.donotes.app') {
              endpoint = `${addr}:7070`;
            }
            try {
                
              const fetchReq = {
                type: 'fetch-data',
                sessionId,
                clientId,
                agent,
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(fetchReq)
              })
              if(!response.ok ) {
                throw new Error('Network response was not ok');                  
              }
              const responseData = await response.json();
              if(responseData && responseData.type) {
                if(responseData.type === 'data-from-server') {
                  try {
                    
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                  }catch(error) {
                    console.error(error)
                  }
                }else if(response.message) {
                  //todo snackbar
                  //setOpenSnackbar(true)
                  //setSnackbarMessage(response.message)
                }
              }
            }
            catch(error) {
              console.error(error)
            }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
  
  async function confirmDelete(id, type) {
    if(clientId && sessionId) {      
      try {let endpoint = `${addr}:6060`
        const agent = window.navigator.userAgent;
        const message = {
          type: `delete-${type}`,
          version: mainVersion,
          agent,
          id,
          clientId,
          sessionId
        }
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(message)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        // If you need to handle the response
        
        const responseData = await response.json();
        if(responseData) {
          let endpoint = 'https://donotes-server.com:7070'
            
            if(window.location.hostname !== 'v8.donotes.app') {
              endpoint = `${addr}:7070`;
            }
            try {
                
              const fetchReq = {
                type: 'fetch-data',
                sessionId,
                clientId,
                agent,
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(fetchReq)
              })
              if(!response.ok ) {
                throw new Error('Network response was not ok');                  
              }
              const responseData = await response.json();
              if(responseData && responseData.type) {
                if(responseData.type === 'data-from-server') {
                  try {
                    
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                  }catch(error) {
                    console.error(error)
                  }
                }else if(response.message) {
                  //todo snackbar
                  //setOpenSnackbar(true)
                  //setSnackbarMessage(response.message)
                }
              }
            }
            catch(error) {
              console.error(error)
            }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
  const newNoteStageTwo = (parent, index) => {
    setNewNote(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: false
      }
    }));
    
    if(inputRef.current[index].value === null || inputRef.current[index].value === undefined || inputRef.current[index].value === '') {
      return;
    }
    
    const name = inputRef.current[index].value
    createNote(name, parent)
  };
  
  const newBoardStageTwo = (path, index) => {
    setNewBoard(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: false
      }
    }));
    
    if(inputRefBoard.current[index].value === null || inputRefBoard.current[index].value === undefined || inputRefBoard.current[index].value === '') {
      return;
    }
    const name = inputRefBoard.current[index].value
    createBoard(name, path)
  };
  
  const newFolderStageTwo = (path, index) => {
    setNewFolder(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: false
      }
    }));
    if(inputFolderRef.current[index].value === null || inputFolderRef.current[index].value === undefined || inputFolderRef.current[index].value === '') {
      return;
    }
    const name = inputFolderRef.current[index].value
    createFolder(name, path)

  };
  const renameFileStageOne = (path, index) => {
    setRenameFile(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: true
      }
    }));

    focusOnRenameInput(index)
  };
  
  const deleteFileStageOne = (path, index) => {
    setDeleteFile(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: true
      }
    }));


  };
  
  
  const handleCancelDelete = ( index) => {
    setDeleteFile(prevState => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        active: false
      }
    }));


  };
  
  const handleConfirmDelete = (id, type) => {
    confirmDelete(id, type)
  }

  async function updateFiles() {
    console.log('updating')
    console.log(targetDrop, targetType)
    console.log(moveItem, moveType)
    let tmpId = moveItem
    let temptpye = moveType
    if(moveItem === undefined) {
      tmpId = 0;
      temptpye = 'folder'
      console.log('fix')
    }
    if(targetDrop && targetType && temptpye) {
      console.log('hi')
      if(temptpye === 'folder') {
        if(clientId && sessionId) {      
          try {let endpoint = `${addr}:6060`
            const agent = window.navigator.userAgent;
            const message = {
              type: 'move-file',
              version: mainVersion,
              newParent: tmpId,
              currentId: targetDrop,
              currentType: targetType,
              parent,
              clientId,
              sessionId,
              agent
            }
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(message)
            });
    
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
    
            // If you need to handle the response
            
            const responseData = await response.json();
            if(responseData) {
              setSnackbarMessage(responseData.message)
              setTimeout(()=>{
                setSnackbar(false)
              }, 4000)
              let endpoint = 'https://donotes-server.com:7070'
                
                if(window.location.hostname !== 'v8.donotes.app') {
                  endpoint = `${addr}:7070`;
                }
                try {
                    
                  const fetchReq = {
                    type: 'fetch-data',
                    sessionId,
                    clientId,
                    agent,
                  }
                  const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(fetchReq)
                  })
                  if(!response.ok ) {
                    throw new Error('Network response was not ok');                  
                  }
                  const responseData = await response.json();
                  if(responseData && responseData.type) {
                    if(responseData.type === 'data-from-server') {
                      try {
                        
                        setAllFiles(JSON.parse(responseData.payload))
                        const storage = JSON.parse(responseData.accountSize)
                        //setStorageUsage(storage[0].storage)
                      }catch(error) {
                        console.error(error)
                      }
                    }else if(response.message) {
                      //todo snackbar
                      //setOpenSnackbar(true)
                      //setSnackbarMessage(response.message)
                    }
                  }
                }
                catch(error) {
                  console.error(error)
                }
            }
          } catch (error) {
            console.error('Error:', error);
          }
        }
      }
    }
  }
  useEffect(()=>{
    
    updateFiles()
  }, [moveType, moveItem, targetDrop, targetType])
      if(1 === 1) {
      
      return (
      <>
      
      {
      items
        .filter(item => item.parent === parent)
        .map((item, index) => (
          <>

<div
  id={item.id}
  draggable={(enableDrag && item.id !== 0 && item.id !== -1 && item.id !== '-1' && item.parent !== '-1') && true}
  onDragStart={(e)=>{
    setTargetDrop()
    setTargetType()

    e.stopPropagation()
    setEnableDrag(false)
    const id = item.id
    const type = item.type
    setMoveItem()
    setMoveType()
  }}
  onDragEnd={(e)=>{
    setEnableDrag(true)
    setTargetDrop(e.target.id)
    setTargetType(e.target.getAttribute('data-droptype'))
    e.target.classList.remove("hover");
  }}
  onDragEnter={(e)=>{
    if(e.target.getAttribute('data-type') === 'folder' && e.target.getAttribute('data-id') !== '-1') {
      e.target.classList.add("hover");

    }
      
    
  }}
  onDragLeave={(e)=>{
    e.target.classList.remove("hover");
  }}
  onDrop={(e)=>{
    e.target.classList.remove("hover");
    console.log(e.target.getAttribute('data-id'))
    setMoveItem(e.target.getAttribute('data-id'))
    setMoveType(e.target.getAttribute('data-type'))

  }}
          data-dropid={item.id} 
          data-id={item.id}
          data-droptype={item.type}
          data-type={item.type}
          className={
              parent ? 
                  (checkedItems[item.id] ? 'treeitem parent' : 'checked treeitem parent') : 
                  (checkedItems[item.id] ? 'treeitem' : 'checked treeitem')
          }
          onClick={()=>{
            if(item.type === 'note') {
              navigate(`/editor/${item.id}`)
            }
          }}
        >
            <label  
            
        tabIndex={`${item.parent}${index}`} 
        onKeyDown={(e)=>{
          if(e.key === 'Enter') {
            
            if(item.type === 'folder') {
              
              handleCheckboxChange(item.id)
            }else if(item.type === 'note') {
              
              navigate(`/editor/${item.id}`)
            }
          }
        }}
        data-id={item.id} data-type={item.type}
        role="button"
            title={`Open ${item.name}`} >
                {item.type === 'note' && 
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="var(--md-sys-color-secondary)"><path d="M200-200h360v-200h200v-360H200v560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm80-280v-80h200v80H280Zm0-160v-80h400v80H280Zm-80 360v-560 560Z"/></svg>
              }
              {item.type === 'board' && 
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"  fill="var(--md-sys-color-secondary)"><path d="M240-120q-45 0-89-22t-71-58q26 0 53-20.5t27-59.5q0-50 35-85t85-35q50 0 85 35t35 85q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T320-280q0-17-11.5-28.5T280-320q-17 0-28.5 11.5T240-280q0 23-5.5 42T220-202q5 2 10 2h10Zm230-160L360-470l358-358q11-11 27.5-11.5T774-828l54 54q12 12 12 28t-12 28L470-360Zm-190 80Z"/></svg>            
              }
              {item.type === 'folder' && 
                <>
                
                  <svg className="chevron" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
                  <input
                    type="checkbox"
                    onChange={() => handleCheckboxChange(item.id)}
                    checked={(item.parent === 'homeroot') && true}
                  />
                  
                </>
              }
              {
                renameFile[index] && renameFile[index].active ?
                <>
                <input 
                      type="text" 
                      placeholder={`${item.name}`} 
                      ref={(element) => inputRenameRef.current[index] = element} 
                      onKeyPress={(event) => {
                        if (event.key === 'Enter') {
                          if(renameFile[index] && renameFile[index].active ) {
                            renameFileStageTwo(item.type,item.id, index);
  
                          }
                        }
                      }} 
                    />
                    <div style={{
                      width: '100vw',
                      height: '100vh',
                      position: 'fixed',
                      zIndex: 3000,
                      top: 0,
                      left: 0,
                    }} onClick={()=>{
                      
                      if(renameFile[index] && renameFile[index].active ) {
                        renameFileStageTwo(item.type,item.id, index);

                      }
                    }}></div>
                </>
                :
                <>{item.name}</>
              }
              
              {
                renameFile[index] && renameFile[index].active ?
                <>
                
                
                <file-button-group>
                  <file-button title={`Confirm rename`} onClick={(e) => {e.preventDefault(); e.stopPropagation(); renameFileStageTwo(item.type,item.id, index)}}>
  
                  <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>                </file-button>
                  <file-button title={`Cancel rename`} onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleCancelRename(index);}}>
  
                  <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>                </file-button>
                  </file-button-group>
                </>
               : (<>
              {!deleteFile[index]  || !deleteFile[index].active ?
                <file-button-group>
                  
              {(item.type === 'folder' && item.parent !== 'shared') &&
              <>
                  <file-button title={`New note in ${item.name}`} onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleCheckboxOpen(item.name); newNoteStageOne(item.id, index)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="M440-240h80v-120h120v-80H520v-120h-80v120H320v80h120v120ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"/></svg>
                  </file-button>
                  
                  <file-button title={`New drawing on ${item.name}`} onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleCheckboxOpen(item.name); newBoardStageOne(item.id, index)}}>
                    
                    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="m499-287 335-335-52-52-335 335 52 52Zm-261 87q-100-5-149-42T40-349q0-65 53.5-105.5T242-503q39-3 58.5-12.5T320-542q0-26-29.5-39T193-600l7-80q103 8 151.5 41.5T400-542q0 53-38.5 83T248-423q-64 5-96 23.5T120-349q0 35 28 50.5t94 18.5l-4 80Zm280 7L353-358l382-382q20-20 47.5-20t47.5 20l70 70q20 20 20 47.5T900-575L518-193Zm-159 33q-17 4-30-9t-9-30l33-159 165 165-159 33Z"/></svg>
                  </file-button>
                  <file-button title={`New folder in ${item.name}`} onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleCheckboxOpen(item.name); newFolderStageOne(item.id, index)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="M560-320h80v-80h80v-80h-80v-80h-80v80h-80v80h80v80ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z"/></svg>
                  </file-button>
              </>
              }
              {(item.parent !== 'homeroot' && item.parent !== 'shared' && item.parent !== '-1') && 
              <>
                  <file-button title={`Rename ${item.name}`} onClick={(e) => {e.preventDefault(); e.stopPropagation();renameFileStageOne(item.id, index)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="M360-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h160v80H200v560h160v80Zm80 80v-880h80v880h-80Zm160-80v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80q0 33-23.5 56.5T760-120Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80q33 0 56.5 23.5T840-760h-80Z"/></svg>
                  </file-button>
                  
                  <file-button title={`Delete ${item.name}`} onClick={(e) => {e.preventDefault(); e.stopPropagation();deleteFileStageOne(item.id, index)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/></svg>
                  </file-button>
                  </>}
                </file-button-group>
                :
                <>
                
                <file-button-group>
                  <file-button title={`Confirm delete`} onClick={(e) => {e.preventDefault(); e.stopPropagation();handleCancelDelete(index); handleConfirmDelete(item.id, item.type)}}>
  
                  <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>                </file-button>
                  <file-button title={`Cancel delete`} onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleCancelDelete(index);}}>
  
                  <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>                </file-button>
                  </file-button-group>
                </>
              }
              </>)
              }

            </label>
            {item.type === 'folder' && <>
            
          <div className={`checked treeitem ${(!newNote[index] || !newNote[index].active) && 'hide-treeitem'}`}>
                  <label data-id={item.type} data-type={item.type}>
                  <input 
                    style={{
                      position: 'relative',
                      zIndex: 3001
                    }}
                    type="text" 
                    placeholder="New note" 
                    ref={(element) => inputRef.current[index] = element} 
                    
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        if(newNote[index] && newNote[index].active ) {
                          newNoteStageTwo(item.id, index);

                        }
                      }
                    }} 
                  />
                  </label>
                  
                  <div
                   className={(!newNote[index] || !newNote[index].active) && 'hide-treeitem'}
                  style={{
                      width: '100vw',
                      height: '100vh',
                      position: 'fixed',
                      zIndex: 3000,
                      top: 0,
                      left: 0,
                    }} onClick={()=>{
                      
                      if(newNote[index] && newNote[index].active ) {
                        newNoteStageTwo(item.id, index);

                      }
                    }}></div>
                </div>
                <div className={`checked treeitem ${(!newBoard[index] || !newBoard[index].active) && 'hide-treeitem'}`}>
                  <label>
                  <input 
                    type="text" 
                    placeholder="New whiteboard" 
                    ref={(element) => inputRefBoard.current[index] = element} 
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        if(newBoard[index] && newBoard[index].active ) {
                          newBoardStageTwo(item.id, index);

                        }
                      }
                    }} 
                  />
                  </label>
                </div>
                <div className={`checked treeitem ${(!newFolder[index] || !newFolder[index].active) && 'hide-treeitem'}`}>
                  <label>
                  <input 
                    type="text" 
                    placeholder="New folder" 
                    ref={(element) => inputFolderRef.current[index] = element} 
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        if(newFolder[index] && newFolder[index].active ) {
                          newFolderStageTwo(item.id, index);

                        }
                      }
                    }} 
                  />
                  </label>
                </div></>}
                {
                  nextList
                   &&
                  <BuildTree addr={addr} allItems={items} nextList={checkedItems[item.id]} parent={item.id} setAllFiles={setAllFiles} sessionId={sessionId} clientId={clientId} />
                }
          </div>
          <Snackbar
            open={snackbar}
            autoHideDuration={4000}
            onClose={()=>{setSnackbar(false)}}
            message={snackbarMessage}
            />
          </>
        ))
          }
        </>)
          }
          
      }
    